/* assets/pdp-disclaimer-badges.js
   Solely Jane -- on-image disclaimer overlay for Base/Top PDP galleries.
   Design Brief Section 5: every base-paired image on a Top PDP, and every
   top-paired image on a Base PDP, needs a small pill overlay reading e.g.
   "Black Base Shown is not included" or "Adelaide Black Top Shown is not
   included" -- driven by that image's own data, not a static caption.

   Implementation: the relevant gallery images already have real alt text
   ending in "is not included" (set directly on the Shopify media objects).
   This script finds gallery <img> elements whose alt text matches that
   pattern and overlays a badge with that exact text. Runs only on product
   pages; a MutationObserver re-scans after the theme's own gallery/zoom
   JS swaps slides in and out. */
(function () {
  'use strict';
  if (!/^\/products\//.test(window.location.pathname)) return;

  var SELECTOR = '.product__media img, .product-media-modal img, .pswp__img, [data-product-media] img, .product__media-item img';

  function decorate(img) {
    if (!img || img.dataset.sjBadgeDone) return;
    var alt = img.getAttribute('alt') || '';
    if (!/is not included\s*$/i.test(alt.trim())) return;
    img.dataset.sjBadgeDone = '1';

    var wrapper = img.closest('.product__media, .product-media-modal, .pswp__zoom-wrap, [data-product-media], .product__media-item') || img.parentElement;
    if (!wrapper) return;
    var computedPosition = window.getComputedStyle(wrapper).position;
    if (computedPosition === 'static') wrapper.style.position = 'relative';

    var badge = document.createElement('div');
    badge.className = 'sj-pdp-disclaimer-badge';
    badge.textContent = alt.trim();
    wrapper.appendChild(badge);
  }

  function scan(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(decorate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  var mo = new MutationObserver(function (muts) {
    var relevant = muts.some(function (m) {
      return m.addedNodes && m.addedNodes.length > 0;
    });
    if (!relevant) return;
    clearTimeout(window.__sjBadgeTimer);
    window.__sjBadgeTimer = setTimeout(function () { scan(); }, 250);
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
